import {
    APPEND_FILTER,
     RESET_FILTER,
     RESET_LANG_FILTER
} from "./actionTypes"

 

export const appendFilters = (payload) => {
    return {
        type: APPEND_FILTER,
        payload: payload
    }
}

export const resetFilters = () => {
    return {
        type:RESET_FILTER
    }
}
export const resetLangFilters=()=>{
    return {
        type:RESET_LANG_FILTER
    }
}
